import { useState } from "react";
import Footer from "../common/Footer";
import "../css/Careers.css";

function Careers() {

  const [fileName, setFileName] = useState("Browse File");

  const handleFile = (e) => {
    if (e.target.files[0]) {
      setFileName(e.target.files[0].name);
    }
  };

  return (
    <>
      <section className="careers-hero">

        <div className="careers-container">

          <div className="careers-left">

            <div className="careers-form-wrapper">

              <form className="careers-form">

                <div className="form-row">
                  <input placeholder="Enter First Name*" />
                  <input placeholder="Enter Last Name*" />
                </div>

                <div className="form-row">
                  <input placeholder="Enter Phone No.*" />
                  <input placeholder="Enter Location*" />
                </div>

                <input className="form-full" placeholder="Enter Email Id*" />

                <div className="upload-box">
                  <div className="upload-circle">↑</div>

                  <p>Upload Resume*</p>
                  <small>File size less than 5 MB. Supports pdf and word.</small>

                  <label className="upload-btn">
                    {fileName}
                    <input type="file" hidden onChange={handleFile} />
                  </label>
                </div>

                <button className="submit-btn">Submit</button>

              </form>

            </div>

            <p className="careers-email">
              Send your resume at <span>nxsa.careers@gmail.com</span>
            </p>

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
}

export default Careers;